var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.043,
    height: 63.043,
    viewBox: "0 0 16.68 16.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0f0",
    d: "M114.23 45.175a8.34 8.34 0 100 16.68 8.34 8.34 0 000-16.68zm-4.041 3.682h8.203l1.024 1.023v5.822l-1.024 1.022h-6.237c-.094.012-.175 0-.351.146l-1.697 1.698a.781.781 0 01-.67.013c-.245-.148-.27-.383-.27-.555V49.88zm.53 1.054l-.497.498v6.66l1.023-1.022c.306-.279.535-.353.91-.376h5.707l.498-.499V50.41l-.498-.498zm1.19 2.187c.17 0 .343.057.475.174a.681.681 0 01.219.52c0 .222-.087.4-.219.517a.714.714 0 01-.475.174.713.713 0 01-.474-.174.676.676 0 01-.22-.517c0-.223.088-.403.22-.52a.713.713 0 01.474-.174zm2.381 0c.17 0 .343.057.475.174a.681.681 0 01.218.52c0 .222-.086.4-.218.517a.714.714 0 01-.475.174.708.708 0 01-.472-.174.676.676 0 01-.22-.517c0-.223.088-.403.22-.52a.708.708 0 01.472-.174zm2.381 0c.17 0 .343.057.475.174a.681.681 0 01.218.52c0 .222-.087.4-.218.517a.713.713 0 01-.475.174.71.71 0 01-.473-.174.675.675 0 01-.218-.517c0-.223.087-.403.218-.52a.71.71 0 01.473-.174z",
    paintOrder: "fill markers stroke",
    transform: "translate(-105.89 -45.175)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.3469f3e11d718846c4322188b940c7d4.svg";
export { ForwardRef as ReactComponent };